import * as React from "react";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { useSelector, useDispatch } from "react-redux";
import {
  bank_icon_2,
  bank_method_icon,
  cash_bank_icon,
  cash_icon_2,
  cash_method_icon,
  clear_icon,
  credit,
  credit_blue,
  delivery_icon,
  return_icon,
} from "../../assets";
import { createOrder } from "../../Redux/Action/createposorderAction";
import { useTranslation } from "react-i18next";
import { storeSelectedPaymentMethod } from "../../Redux/Action/paymentAction";
import { toast } from "react-toastify";
import i18next from "i18next";
import { detectWebDeviceType, isTablet } from "../../utils";
// import LoadingSpinner from './LoadingSpinner'; // Import LoadingSpinner component

const LoadingSpinner = () => {
  return (
    <div
      style={{ zIndex: 50 }}
      className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50"
    >
      <div className="spinner">
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
      </div>
    </div>
  );
};

function OrderFromButton({ paymentMethod, selected, onClick, disabled }) {
  const { t, i18n } = useTranslation();

  // const getIcon = (method) => {
  //   switch (method) {
  //     case "Cash":
  //       // return cash_method_icon;
  //       return cash_icon_2;
  //     case "Bank":
  //       return bank_icon_2;
  //     // return bank_method_icon;
  //     case "Delivery":
  //       return delivery_icon;
  //     case "Cash & Bank":
  //       return cash_bank_icon;
  //     case "Credit Card":
  //       return bank_icon_2;
  //     case "InstaPay":
  //       return bank_icon_2;
  //     case "Credit":
  //       return credit_blue;

  //     default:
  //       return null;
  //   }
  // };

  const getPaymentMethodName = (method) => {
    switch (method) {
      case "self_delivery":
        return t("Self Delivery");
      default:
        return t(method);
    }
  };
  // console.log("paymentMethod",paymentMethod);

  return (
    <div
      className={`flex items-center  justify-center  gap-2 mt-5 px-8 py-5 text-l font-semibold rounded-xl border-2 border-solid shadow-sm cursor-pointer whitespace-nowrap ${selected ? " border-blue-900 border-4" : ""
        } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      onClick={onClick}
      disabled={disabled}
      style={{
        backgroundColor: paymentMethod?.background_color
          ? paymentMethod?.background_color
          : "#7EC242",
        color: paymentMethod?.text_color ? paymentMethod?.text_color : "#fff",
      }}
    >
      {/* {getIcon(paymentMethod.name) && (
        <img
          src={getIcon(paymentMethod.name)}
          alt={`${paymentMethod.name} icon`}
          className={`w-10  ${selected ? "" : "filter grayscale"}`}
        />
      )} */}
      {getPaymentMethodName(paymentMethod.name)}
    </div>
  );
}

function PaymentButton({ paymentMethod, selected, onClick, disabled }) {
  const { t, i18n } = useTranslation();
  const deviceType = detectWebDeviceType();

  const getIcon = (method) => {
    switch (method) {
      case "Cash":
        // return cash_method_icon;
        return cash_icon_2;
      case "Bank":
        return bank_icon_2;
      // return bank_method_icon;
      case "COD":
        return delivery_icon;
      case "Cash & Bank":
        return cash_bank_icon;
      case "Credit Card":
        return bank_icon_2;
      case "InstaPay":
        return bank_icon_2;
      case "Credit":
        return credit_blue;

      default:
        return bank_icon_2;
    }
  };

  const getPaymentMethodName = (method) => {
    switch (method) {
      case "Cash":
        return t("Cash");
      case "Bank":
        return t("Bank");
      case "COD":
        return t("COD");
      case "Cash & Bank":
        return t("Cash & Bank");
      case "Credit Card":
        return t("Credit Card");
      case "InstaPay":
        return t("InstaPay");
      case "Credit":
        return t("Credit");
      default:
        return t(method);
    }
  };
  const getButtonWidth = (method) => {
    switch (method) {
      case "Cash":
        return "39%";
      case "COD":
        return "56%";
      case "Bank":
        return "46%";
      case "Cash & Bank":
        return "56%";
      case "Credit Card":
        return "48%";
      case "InstaPay":
        return "56%";
      case "Credit":
        return "100%";
      default:
        return "48%";
    }
  };

  return (
    <div
      className={`flex flex-col items-center h-13 py-2 text-l font-semibold rounded-lg border-2 border-solid shadow-sm cursor-pointer whitespace-nowrap ${selected
        ? "text-blue-900 bg-white border-blue-900"
        : "bg-white border border-solid border-stone-300 text-zinc-600"
        } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      onClick={onClick}
      style={{
        width: "45%",
        marginInlineEnd: 10, // ✅ Adds spacing to the right in LTR and left in RTL
        marginBottom: 10,
      }}
    >
      
      {getIcon(paymentMethod.name) && deviceType != "tablet" && (
        <img
          src={getIcon(paymentMethod.name)}
          alt={`${paymentMethod.name} icon`}
          className={`w-10 h-8 ${selected ? "" : "filter grayscale"}`}
        />
      )}
      {getPaymentMethodName(paymentMethod.name)}
    </div>
  );
}

function KeypadButton({
  value,
  className,
  onClick,
  children,
  isBankPaymentSelected,
  grandTotal,
  selectedPaymentMethod,
  orderFromOptions,
}) {
  return (
    <button
      type="button"
      className={`flex justify-center items-center ${orderFromOptions.length > 0 ? "h-[119px]" : "h-[93px]"
        } w-40 rounded ${isBankPaymentSelected ||
          grandTotal < 0 ||
          selectedPaymentMethod?.name === "COD" ||
          selectedPaymentMethod?.name === "Credit"
          ? "opacity-50"
          : ""
        } ${className}`}
      onClick={
        isBankPaymentSelected || selectedPaymentMethod?.name === "COD"
          ? null
          : onClick
      }
      // className={`flex justify-center items-center h-[93px] w-40 rounded ${
      //   isBankPaymentSelected ||
      //   grandTotal < 0 ||
      //   selectedPaymentMethod?.name == "Delivery" ||
      //   selectedPaymentMethod?.name == "Credit"
      //     ? "opacity-50"
      //     : ""
      // } ${className}`}
      // onClick={
      //   isBankPaymentSelected || selectedPaymentMethod?.name == "Delivery"
      //     ? null
      //     : onClick
      // }
      disabled={
        isBankPaymentSelected ||
        grandTotal < 0 ||
        selectedPaymentMethod?.name == "COD" ||
        selectedPaymentMethod?.name == "Credit"
      }
      style={{
        marginInlineEnd: 12, // Adds horizontal spacing (LTR/RTL support)
      }}
    >
      {children || value}
    </button>
  );
}
const dummyPaymentMethods = [
  // { name: "Cash" },
  // { name: "Bank" },
  { name: "COD" },
  { name: "Cash & Bank" },
  // { name: "InstaPay" },
  // { name: "Credit Card" },

  { name: "Credit" },
];

function Payment_Modal({
  onClose,
  isCompanyCheckout,
  grandTotal,
  handleCheckout,
  setTenderCash,
  creditAmount,
  setCreditAmount,
  deliveryCheck,
  deliveryFee,
  setDeliveryFee,
  returnDeliveryFee,
  setReturnDeliveryFee,
  showReturnDelivery,
  constReturnDeliveryFee,
  discountType,
  setDiscountType,
  discountValue,
  setDiscountValue,
  originalTotal,
  totalBillAmount,
  totalCostPrice
}) {
  const { t, i18n } = useTranslation();
  const deviceType = detectWebDeviceType();

  const { user } = useSelector((state) => state?.login);
  const [totalPaid, setTotalPaid] = useState("");
  const [ReturnTotal, setReturnTotal] = useState("");
  const [change, setChange] = useState("");
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();

  const [isBankPaymentSelected, setIsBankPaymentSelected] = useState(false);
  // const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [orderFromOptions, setOrderFromOptions] = useState([]);
  const [selectedOrderFrom, setSelectedOrderFrom] = useState();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [activePaymentIndex, setActivePaymentIndex] = useState(0);
  const [activeOrderFromIndex, setActiveOrderFromIndex] = useState("");
  const isETAenabled = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_eta_enabled
  );
  const returnProducts = useSelector(
    (state) => state.returnProductReducer.products
  );

  const allowDiscount = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_allow_discount
  );
  const localProducts = useSelector((state) => state.products.products);

  const [cashPaid, setCashPaid] = useState(0);
  const [remainingAmount, setRemainingAmount] = useState(grandTotal);
  const totalPaidInputRef = React.useRef(null);
  const getCustomerState = useSelector(
    (state) => state?.getcustomer?.selectedCustomer
  );
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);


  const dispatch = useDispatch();

const calculateTotalTax = (products) => {
  return products.reduce((total, product) => {
    const price = Number(product.price_after_discount) || 0;
    const qty = Number(product.quantity) || 1;

    const taxPercentage =
      isETAenabled && product?.vat_details?.tax_id 
        ? Number(product?.vat_details?.tax_rate_percent) || 0
        : 0;

    const tax = (price * qty * taxPercentage) / (100 + taxPercentage);

    return total + tax;
  }, 0);
};

const totalTax = calculateTotalTax(localProducts);

console.log("totalTax===>",totalTax);


  const getPaymentMethod = async (userID) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.PAYMENT_METHODS, {
        user_id: userID,
      });
      if (response?.data.result.data != null) {
        const methods = response.data.result.data.map((method) => ({
          name: method.name,
          id: method.id,
          is_cash_bank: method.is_cash_bank,
          cash_id: method.cash_payment_method_id,
          bank_id: method.bank_payment_method_id,

        }));
        setPaymentMethods([...methods]);
        const cashIndex = methods.findIndex((method) => method.name === "Cash");

        if (cashIndex !== -1) {
          handlePaymentMethodClick(methods[cashIndex], selectedOrderFrom);
          setSelectedPaymentMethod(methods[cashIndex]);
          setActivePaymentIndex(cashIndex); // set index of "Cash"
        }
      }
    } catch (err) {
      console.error(err);
      setErrorMessage("Failed to fetch payment methods.");
    } finally {
      setLoading(false);
    }
  };

  const getOrderFrom = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.ORDER_FROM, {
        user_id: user_id,
        lang: i18next.language === "ar" ? "ar_001" : "en_US",
      });

      const posOrderFrom = response?.data?.result?.[0]?.pos_order_from;


      setOrderFromOptions(posOrderFrom);
      setSelectedOrderFrom(posOrderFrom[0]);
      setActiveOrderFromIndex(0);
      getOrderFromMethods(posOrderFrom[0]?.id, posOrderFrom[0]);
    } catch (err) {
      console.error(err);
      setErrorMessage("Failed to fetch order from options.");
    } finally {
      setLoading(false);
    }
  };

  const getOrderFromMethods = async (id, company) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.ORDER_FROM_METHOD, {
        user_id: user_id,
        pos_order_from_id: id,
      });
      if (response?.data?.result?.status_code == 200) {
        setPaymentMethods(response?.data?.result?.data);
        const cashIndex = response?.data?.result?.data?.findIndex(
          (method) => method.name === "Cash"
        );
        console.log("cashIndex===>", company);

        if (cashIndex !== -1) {
          handlePaymentMethodClick(
            response?.data?.result?.data[cashIndex],
            company
          );
          setSelectedPaymentMethod(response?.data?.result?.data[cashIndex]);
          setActivePaymentIndex(cashIndex); // set index of "Cash"
        } else {
          handlePaymentMethodClick(response?.data?.result?.data[0], company);
        }
      } else {
        setPaymentMethods([]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  const getCreditAomunt = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.GET_CUSTOMER_CREDIT, {
        phone: getCustomerState?.mobile,
      });


      if (
        response?.data?.result[0].status_code === 200 &&
        response?.data?.result[0].status === "Customer Credits"
      ) {
        setCreditAmount(response?.data?.result[0]);
      }
    } catch (err) {
      console.error(err);
      setErrorMessage("Failed to fetch credit amount.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (isCompanyCheckout) {
      getOrderFrom();
    }
  }, [user?.result?.user_id]);


  useEffect(() => {
    if (!deliveryCheck && !isCompanyCheckout) {
      getPaymentMethod(user?.result?.user_id);
    }


    if (getCustomerState) {
      getCreditAomunt();
    }
  }, [user?.result?.user_id, getCustomerState]);

  const keypadValues = [
    [
      {
        value: "1",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "2",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "3",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "10",
        className:
          "text-white bg-[#7EC242]  border border-[#7EC242] hover:bg-[#7EC242]",
      },
    ],
    [
      {
        value: "4",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "5",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "6",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "20",
        className:
          "text-white bg-[#7EC242]  border border-[#7EC242] hover:bg-[#7EC242]",
      },
    ],
    [
      {
        value: "7",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "8",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "9",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "50",
        className:
          "text-white bg-[#7EC242]  border border-[#7EC242] hover:bg-[#7EC242]",
      },
    ],
    [
      {
        value: ".",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "0",
        className:
          "bg-gradient-to-t from-[#EEEEEE] via-[#FFFFFF] to-[#EEEEEE] border border-gray-300 hover:bg-gray-200",
      },
      {
        value: "200",
        className:
          "text-white bg-[#7EC242]  border border-[#7EC242] hover:bg-[#7EC242]",
      },
      {
        value: "100",
        className:
          "text-white bg-[#7EC242]  border border-[#7EC242] hover:bg-[#7EC242]",
      },
    ],
  ];

  const handleKeypadButtonClick = (value) => {
    if (
      totalPaid.length >= 10 &&
      value !== "C" &&
      value !== "." &&
      !["50", "100", "200"].includes(value)
    ) {
      return;
    }

    if (value === "C") {
      setTotalPaid("");
      setTenderCash(0);
      setChange("");
    } else if (value === ".") {
      if (!totalPaid.includes(".")) {
        setTotalPaid((prevTotalPaid) => prevTotalPaid + ".");
        setTenderCash((prevTotalPaid) => prevTotalPaid + "." || 0);
      }
    } else if (!isNaN(parseInt(value, 10))) {
      if (["50", "100", "200", "20", "10"].includes(value)) {
        const updatedTotalPaid = parseFloat(totalPaid || 0) + parseFloat(value);
        setTotalPaid(updatedTotalPaid.toString());
        setTenderCash(updatedTotalPaid.toString() || 0);
        const changeNumeric =
          updatedTotalPaid -
          parseFloat(String(grandTotal).replace(/[^0-9.]/g, ""));
        setChange(`${Math.max(changeNumeric, 0)}`);
      } else {
        const updatedTotalPaid = totalPaid + value;
        setTotalPaid(updatedTotalPaid);
        setTenderCash(updatedTotalPaid || 0);
        const numericValue = parseFloat(
          updatedTotalPaid.replace(/[^0-9.]/g, "")
        );
        const changeNumeric =
          numericValue - parseFloat(String(grandTotal).replace(/[^0-9.]/g, ""));
        setChange(`${Math.max(changeNumeric, 0)}`);
      }

      if (selectedPaymentMethod?.name === "Cash & Bank") {
        const updatedTotalPaid = totalPaid + value;
        const numericValue = parseFloat(
          updatedTotalPaid.replace(/[^0-9.]/g, "")
        );

        const remainingAmount = grandTotal - numericValue;
        setRemainingAmount(Math.max(remainingAmount, 0)); // Ensure it's not negative
      }
    }
    setErrorMessage("");
  };

  const handlePaymentMethodClick = (method, company) => {
    console.log("companyName==>", company?.name, company?.delivery_fee);
    console.log("METRHOFFFFFFFF==>", method);


    if (grandTotal <= 0 && method.name === "Cash") setTotalPaid(0);
    if (company?.name === "self_delivery") {
      setDeliveryFee(company?.delivery_fee ? company?.delivery_fee : 0);
    } else if (method.name === "COD") {
      setDeliveryFee(
        selectedOrderFrom?.delivery_fee ? selectedOrderFrom?.delivery_fee : 0
      ); // Reset delivery fee when selecting Delivery
    } else {
      setDeliveryFee(null);
    }
    if (
      (grandTotal <= 0 && method.name === "Bank") ||
      (grandTotal <= 0 && method.name === "Credit Card") ||
      (grandTotal <= 0 && method.name === "InstaPay") ||
      (grandTotal <= 0 && method.name === "Cash & Bank") ||
      (grandTotal <= 0 && method.name === "COD")
    )
      return;
    dispatch(storeSelectedPaymentMethod(method));
    setSelectedPaymentMethod(method);
    setActivePaymentIndex(paymentMethods.indexOf(method));

    if (method.name === "Cash & Bank") {
      console.log("SELEDTED METHODDD--->", paymentMethods);

      const cashMethod = paymentMethods?.find((m) => m.name === "Cash");
      const bankMethod = paymentMethods?.find((m) => m.name === "Bank");

      if (cashMethod && bankMethod) {
        // Set the selected payment method to include both IDs
        method = {
          name: method.name,
          id: {
            cashId: cashMethod.id,
            bankId: bankMethod.id,
          },
        };
        setSelectedPaymentMethod(method);
      }
      setIsBankPaymentSelected(false);
      setCashPaid(0); // Reset cash paid
      setRemainingAmount(grandTotal); // Set remaining amount to grand total
      setTotalPaid(""); // Clear total paid input
      setChange(""); // Clear change
    } else if (
      method.name === "Bank" ||
      method.name === "Credit Card" ||
      method.name === "InstaPay" ||
      method?.name == "COD" ||
      method?.name === "Fawry" ||
      method?.name === "Prepaid" ||
      method?.name === "PayU" ||
      method?.name === "ValU"
    ) {
      setIsBankPaymentSelected(true);
      setTenderCash(String(grandTotal) || 0);
      setTotalPaid(String(grandTotal));
      setChange("0");
    } else if (method.name === "COD") {
      const cashMethod = paymentMethods.find((m) => m.name === "Cash");
      if (cashMethod) {
        method = {
          name: method.name,
          id: cashMethod.id, // Pass the ID of the Cash method
        };
        setSelectedPaymentMethod(method);
      }

      setIsBankPaymentSelected(false);
      // setTenderCash(String(grandTotal));
      setTotalPaid(0);
      setTenderCash(0);
      setChange("0");
    }
    else if (method.name === "Credit") {
      // console.log("CRREEDITITTTTTTT=======================");


      setIsBankPaymentSelected(false);
      setTotalPaid(0);
      setTenderCash(0);
      setChange("0");
    }
    else {
      setIsBankPaymentSelected(false);
      setTenderCash(0);
      setTotalPaid("");
      setChange("");
    }
    setErrorMessage("");
  };

  const handleOrderFromClick = (method) => {
    if (selectedOrderFrom?.id === method?.id) {
      return;
    } else {
      getOrderFromMethods(method?.id, method);
      setSelectedOrderFrom(method);
      setActiveOrderFromIndex(orderFromOptions.indexOf(method));
    }
  };

  const handleCheckoutClick = (event) => {
    // console.log("SELECTED PM", selectedPaymentMethod);
    if (errorMessage) {
      toast.error(
        t(`The Return Delivery Fee cannot exceed EGP ${constReturnDeliveryFee}`)
      );
      return;
    }

    handleCheckout(selectedPaymentMethod, selectedOrderFrom);
  };


  const handleClearButtonClick = () => {
    if (!isBankPaymentSelected) {
      setTotalPaid("");
      setChange("");
      setRemainingAmount(0);
      setDiscountType("");
      setDiscountValue(0);
    }
  };

  useEffect(() => {
    if (grandTotal < 0) {
      setTotalPaid(grandTotal.toString());
      setIsBankPaymentSelected(true);
    }
  }, [grandTotal]);

  const handleKeyPress = (event) => {
    const normalizedKey =
      {
        // ش: "Enter", // Arabic "ش" is similar to English "Enter"
        x: "ء", // Arabic "Ctrl+X" will be normalized to "x" when Ctrl is pressed
      }[event.key] || event.key; // Fallback to the original key if no mapping exists

    if (event.key === "Enter") {
      event.preventDefault();
      if (
        selectedPaymentMethod?.name === "Cash & Bank" &&
        totalPaid >= grandTotal
      ) {
        return;
      }
      if (
        (selectedPaymentMethod?.name === "Cash & Bank" && totalPaid > 0) ||
        (selectedPaymentMethod?.name === "Cash" && totalPaid >= grandTotal)
      ) {
        handleCheckoutClick(event);
      } else if (
        selectedPaymentMethod?.name === "Bank" &&
        totalPaid == grandTotal
      ) {
        handleCheckoutClick(event);
      } else if (selectedPaymentMethod?.name === "COD") {
        handleCheckoutClick(event);
      } else if (selectedPaymentMethod?.name === "Credit") {
        handleCheckoutClick(event);
      }
      // if (totalPaid > grandTotal || totalPaid == grandTotal)
      //   handleCheckoutClick(event);
    } else if (event.shiftKey && normalizedKey === "Shift") {
      event.preventDefault();
      if (
        (grandTotal <= 0 && selectedPaymentMethod?.name === "Bank") ||
        grandTotal <= 0
      ) {
        return;
      }

      const nextIndex = (activePaymentIndex + 1) % paymentMethods.length;
      setActivePaymentIndex(nextIndex);
      setSelectedPaymentMethod(paymentMethods[nextIndex]);
      handlePaymentMethodClick(paymentMethods[nextIndex], selectedOrderFrom);
    } else if (event.ctrlKey && normalizedKey === "ء") {
      // Handle Ctrl+X
      event.preventDefault();
      handleClearButtonClick();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [
    totalPaid,
    grandTotal,
    selectedPaymentMethod,
    activePaymentIndex,
    handleClearButtonClick,
  ]);

  useEffect(() => {
    if (
      selectedPaymentMethod?.name === "Cash" ||
      selectedPaymentMethod?.name === "Cash & Bank"
    ) {
      totalPaidInputRef.current?.focus(); // Focus the input field
    }
  }, [selectedPaymentMethod]);





  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50 backdrop-blur-md drop-shadow-sm">
      {loading && <LoadingSpinner />}

      <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40"></div>
      <section
        className="relative flex flex-col py-10 text-lg font-semibold  bg-white rounded-[15px] text-zinc-800 max-md:px-5 z-40 mt-8"
        style={{ width: isCompanyCheckout ? "1350px" : "1120px" }}
      >
        <button
          type="button"
          onClick={onClose}
          className={`bg-transparent absolute top-4 text-zinc-800" ${i18n.language === "ar" ? "left-3" : "right-3"}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-8 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <main className="flex">
          {isCompanyCheckout && (
            <div className=" border-e border-[#D9D9D9] px-6">
              <div className="text-xl font-semibold tracking-wider text-[#5C5C5C]">
                {t("Company Delivery")}
              </div>
              <div className="justify-center w-full mt-8">
                {orderFromOptions.map((method, index) => {

                  return (
                    <OrderFromButton
                      key={method.id}
                      paymentMethod={method}

                      selected={selectedOrderFrom?.id === method.id}
                      onClick={() => handleOrderFromClick(method)}

                      disabled={grandTotal <= 0}
                    />
                  );
                  // }
                  // return null;
                })}
              </div>
            </div>
          )}

          <div className="flex ms-5 flex-1 gap-7 max-md:flex-col">
            <div className="flex flex-col w-4/12 max-md:w-full h-full">
              <div className="flex flex-col gap-3 h-full">


                {(totalBillAmount != grandTotal) && (
                  <div className="text-2xl mb-4 font-semibold tracking-wider text-[#5C5C5C]">
                    {t("Total Bill")}
                  </div>
                )}

                <div className="text-2xl font-semibold tracking-wider text-[#5C5C5C]">
                  {t("Grand Total")}
                </div>


                {/* {(
                  (isCompanyCheckout && selectedOrderFrom?.name === "self_delivery" && allowDiscount) ||
                  (!isCompanyCheckout && allowDiscount)
                ) && (<div className="text-2xl mt-3 font-semibold tracking-wider text-[#5C5C5C]">
                  {t("Discount Applied")}
                </div>
                  )} */}


                <div className="text-2xl font-bold mt-5 tracking-wider text-[#5C5C5C] mt-2">
                  {/* {t("Total Paid")} */}
                  {selectedPaymentMethod?.name === "Cash & Bank"
                    ? t("Total paid by cash")
                    : t("Total Paid")}
                </div>
                {grandTotal > 0 && (
                  <div className="text-2xl font-bold  mt-5 tracking-wider text-[#5C5C5C] mt-2">
                    {/* {t("Change")} */}
                    {selectedPaymentMethod?.name === "Cash & Bank"
                      ? t("Total paid by bank")
                      : t("Change")}
                  </div>
                )}
                {creditAmount?.response && (
                  <div className="text-2xl font-bold  mt-5 tracking-wider text-[#5C5C5C] mt-2">
                    {t("Balance Credit Amount")}
                  </div>
                )}

                {showReturnDelivery && (
                  <div className="text-2xl font-bold  mt-5 tracking-wider text-[#5C5C5C] mt-2">
                    {t("Refund Delivery Fee")}
                  </div>
                )}

                {(selectedOrderFrom?.name === 'self_delivery' || selectedPaymentMethod?.name === "COD") && (
                  <div className="text-2xl font-bold  mt-5 tracking-wider text-[#5C5C5C] mt-2">
                    {t("Delivery Fee")}
                  </div>
                )}
                <div className="flex flex-col capitalize max-md:flex-wrap">
                  <span className="mt-2 text-gray-600 italic mb-2">
                    {t("Payment Options")}
                  </span>
                  <div className="flex flex-wrap w-full ms-3">
                    {paymentMethods?.map((method, index) => {
                      return (
                        <PaymentButton
                          key={method.id} // Use the id as the key
                          paymentMethod={method}
                          selected={
                            selectedPaymentMethod?.name === method.name ||
                            activePaymentIndex === index
                          }
                          onClick={() =>
                            handlePaymentMethodClick(method, selectedOrderFrom)
                          }
                          disabled={grandTotal <= 0 && method.name != "Cash"}
                        />
                      );
                    })}
                  </div>
                </div>

                <div className="flex-grow"></div>
                <button
                  disabled={
                    (selectedPaymentMethod?.name === "Cash & Bank" &&
                      totalPaid <= 0) ||
                    (selectedPaymentMethod?.name === "Cash" &&
                      totalPaid < grandTotal) ||
                    (selectedPaymentMethod?.name === "Cash & Bank" &&
                      totalPaid >= grandTotal)
                  }
                  onClick={handleCheckoutClick}
                  className={`justify-center items-center mt-2  me-2.5 text-3xl text-center text-white capitalize whitespace-nowrap bg-[#1b4597] rounded-lg max-md:px-5 max-md:mt-10 max-md:max-w-full ${orderFromOptions.length > 0 ? "py-[12%]" : "py-[12%]"
                    }`}
                  style={{
                    opacity:
                      (selectedPaymentMethod?.name === "Cash & Bank" &&
                        totalPaid <= 0) ||
                        (selectedPaymentMethod?.name === "Cash & Bank" &&
                          totalPaid >= grandTotal) ||
                        (selectedPaymentMethod?.name === "Cash" &&
                          totalPaid < grandTotal)
                        ? 0.5
                        : 1,
                  }}
                >
                  {t("Done")}
                </button>
              </div>
            </div>

            <div className="flex flex-col w-8/12 max-md:w-full -me-24">

              {/* Tota Paid  */}

              {/* Total Bill  */}
              <div className="flex flex-row gap-8" dir={i18n.language === "ar" ? "rtl" : "ltr"}>
                <div>

                  {(totalBillAmount != grandTotal) && (

                    <div
                      className={`flex h-[40px] mb-4 overflow-hidden w-7/12 justify-center items-start ${i18n.language === "ar" ? "flex-row-reverse " : ""
                        }`}
                    >
                      <span className="inset-y-0 flex items-center pl-3 text-2xl text-black">
                        EGP
                      </span>
                      <input
                        type="number"
                        className="text-left  w-full px-5 font-bold text-zinc-800 text-2xl"

                        value={
                          i18n.language === "ar" && totalBillAmount < 0
                            ? `${-totalBillAmount.toFixed(2)}-`
                            : parseFloat(totalBillAmount).toFixed(2)
                        }
                        readOnly
                      />
                    </div>
                  )}

                  {/* Grand Total  */}

                  <div
                    className={`flex h-[40px] overflow-hidden w-10/12 justify-start items-center ${i18n.language === "ar" ? "flex-row-reverse " : ""
                      }`}
                  >
                    <span className="inset-y-0 flex items-center pl-3 text-2xl text-black">
                      EGP
                    </span>
                    <span className="inset-y-0 flex items-center pl-3 text-2xl text-black">
                      {
                        i18n.language === "ar" && grandTotal < 0
                          ? `${-grandTotal.toFixed(2)}-`
                          : parseFloat(grandTotal).toFixed(2)
                      }
                    </span>
                    {/* <input
                      type="number"
                      className="text-left  w-full px-5 font-bold text-zinc-800 text-2xl"

                      value={
                        i18n.language === "ar" && grandTotal < 0
                          ? `${-grandTotal.toFixed(2)}-`
                          : parseFloat(grandTotal).toFixed(2)
                      }
                      readOnly
                    /> */}
                    {isETAenabled &&
                    <span className="inset-y-0 flex items-center pl-3 text-2xl text-gray-600 ">{`(Tax: EGP ${totalTax.toFixed(2)})`}</span>
                    }
                  </div>

                  {/* Discount Applied Section */}
                  {/* {(
                    (isCompanyCheckout && selectedOrderFrom?.name === "self_delivery" && allowDiscount) ||
                    (!isCompanyCheckout && allowDiscount)
                  ) && (
                  <div className="mt-2 mb-4">

                    <div className="flex items-center gap-5">

                      <label className="flex items-center gap-2 text-xl">
                        <input
                          type="radio"
                          name="discountType"
                          value="percentage"
                          checked={discountType === "percentage"}
                          onChange={() => {
                            setDiscountType("percentage");
                            setDiscountValue("");
                          }}
                          className="h-5 w-5"
                        />
                        {t("Percentage")}
                      </label>

                      <label className="flex items-center gap-2 text-xl">
                        <input
                          type="radio"
                          name="discountType"
                          value="value"
                          checked={discountType === "value"}
                          onChange={() => {
                            setDiscountType("value");
                            setDiscountValue("");
                          }}
                          className="h-5 w-5"
                        />
                        {t("Value")}
                      </label>

                      {discountType && (
                        <div className="relative w-[250px]">

                          {discountType === "value" && (
                            <span
                              className={`absolute inset-y-0  flex items-center text-xl text-gray-600 ${i18n.language === "ar" ? "right-3" : "left-3"}`}
                            >
                              EGP
                            </span>
                          )}

                          <input
                            type="number"
                            placeholder={
                              discountType === "percentage"
                                ? t("Enter %")
                                : t("Enter amount")
                            }
                            className={`border border-gray-300 rounded-lg  pe-3 py-2 w-full text-xl focus:outline-none focus:border-1px ${discountType === "percentage" ? "ps-4" : "ps-14"}`}
                            value={discountValue}

                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e" || e.key === "E") {
                                e.preventDefault();
                              }
                            }}


                            onChange={(e) => {
                              let value = e.target.value;

                              value = value.replace(/[^0-9.]/g, "");

                              value = value.replace(/(\..*)\./g, "$1");

                              if (value.includes(".")) {
                                const [intPart, decimalPart] = value.split(".");
                                if (decimalPart.length > 2) {
                                  return; // block input
                                }
                              }

                              let numeric = parseFloat(value);

                              if (isNaN(numeric)) {
                                setDiscountValue("");
                                return;
                              }

                              if (discountType === "value") {
                                if ((originalTotal - numeric) < totalCostPrice) {
                                  toast.error(t("The Discount price cannot be less than the Cost price"));
                                  return;
                                }
                              }
                              console.log("totalCostPrice--->", totalCostPrice);
                          const percentSalePrice = originalTotal - ((originalTotal * numeric)/100);

                              if (discountType === "percentage") {
                                if (percentSalePrice < totalCostPrice) {
                                  toast.error(t("The Discount price cannot be less than the Cost price"));
                                  return;
                                }
                              }

                              if (selectedPaymentMethod?.name === "Cash & Bank") {
                                setTotalPaid("");
                                setRemainingAmount(0)
                              }
                              if (selectedOrderFrom?.name === "self_delivery") {
                                if (numeric > (originalTotal - deliveryFee)) {
                                  toast.error(t("The Discount price cannot be less than the Cost price"));
                                  return;
                                }
                              }



                              setDiscountValue(value);
                            }}

                          />
                        </div>
                      )}

                    </div>
                  </div>
                    )} */}


                  <div className="flex align-middle justify-between w-full  ">
                    <div

                      className={`flex bg-white mt-1 w-[400px] rounded-lg h-[60px] overflow-hidden justify-center items-start ${isBankPaymentSelected ||
                        grandTotal < 0 ||
                        selectedPaymentMethod?.name === "COD" ||
                        selectedPaymentMethod?.name === "Credit" ||
                        selectedPaymentMethod?.name === "ValU" ||
                        selectedPaymentMethod?.name === "Fawry" ||
                        selectedPaymentMethod?.name === "Prepaid" ||
                        selectedPaymentMethod?.name === "PayU"
                        ? "" // No border class
                        : "border border-solid border-stone-300" // Apply border class
                        } ${i18n.language === "ar" ? "flex-row-reverse" : ""}`}
                    >
                      <span className={`inset-y-0 flex items-center py-3.5 text-2xl text-black" ${i18n.language === "ar" ? "px-6" : "px-3"}`}>
                        EGP
                      </span>
                      <input
                        id="textInput1"
                        ref={totalPaidInputRef}
                        type="number"
                        autoFocus={true}
                        //  readOnly={true}
                        onFocus={
                          deviceType === "tablet" ? (e) => e.target.blur() : undefined
                        }
                        className="bg-white text-left h-[62px] w-full focus:outline-none  font-bold text-zinc-800 text-2xl"
                        value={
                          isBankPaymentSelected
                            ? grandTotal.toFixed(2)
                            : grandTotal <= 0
                              ? "0"
                              : totalPaid
                        }
                        readOnly={
                          isBankPaymentSelected ||
                          grandTotal < 0 ||
                          selectedPaymentMethod?.name == "COD" ||
                          selectedPaymentMethod?.name == "Credit" ||
                          selectedPaymentMethod?.name === "Fawry" ||
                          selectedPaymentMethod?.name === "Prepaid" ||
                          selectedPaymentMethod?.name === "PayU"
                        }
                        style={{ direction: "ltr" }}
                        onChange={(e) => {
                          // Get the input value
                          let inputValue = e.target.value;

                          // Replace Arabic decimal separator with a period
                          inputValue = inputValue.replace(/ز/g, ".");

                          // Remove any non-numeric characters except the decimal point
                          const sanitizedValue = inputValue.replace(
                            /[^0-9.]/g,
                            ""
                          );

                          // Validate the sanitized value
                          if (/^\d*\.?\d{0,2}$/.test(sanitizedValue)) {
                            setTotalPaid(sanitizedValue);
                            setTenderCash(sanitizedValue || 0);

                            // Calculate the change
                            const numericValue =
                              parseFloat(sanitizedValue) || 0;
                            const grandTotalValue =
                              parseFloat(
                                String(grandTotal).replace(/[^0-9.]/g, "")
                              ) || 0;
                            const changeNumeric =
                              numericValue - grandTotalValue;

                            // Set the change ensuring it's not negative
                            setChange(`${Math.max(changeNumeric, 0)}`);

                            if (selectedPaymentMethod?.name === "Cash & Bank") {
                              const remainingAmount =
                                grandTotalValue - numericValue;
                              setRemainingAmount(Math.max(remainingAmount, 0)); // Ensure it's not negative
                            }
                          }
                        }}
                        maxLength={7}
                      />
                    </div>
                    <button
                      className={`justify-center items-center text-xl text-white bg-[#F42020] ms-3 mt-1 w-[250px] h-[60px] rounded-lg border border-solid border-stone-300 max-md:px-5 ${isBankPaymentSelected ||
                        selectedPaymentMethod?.name === "Credit" ||
                        selectedPaymentMethod?.name === "COD" ||
                        grandTotal < 0
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                        }`}
                      onClick={
                        isBankPaymentSelected ||
                          selectedPaymentMethod?.name === "Credit" ||
                          selectedPaymentMethod?.name === "COD"
                          ? null
                          : handleClearButtonClick
                      }
                      style={{
                        opacity:
                          isBankPaymentSelected ||
                            selectedPaymentMethod?.name === "Credit" ||
                            selectedPaymentMethod?.name === "COD" ||
                            grandTotal < 0
                            ? 0.5
                            : 1,
                      }} // Apply inline style for opacity
                    >
                      {t("Clear")}
                    </button>
                  </div>



                  {grandTotal > 0 && (
                    <div
                      className={`flex rounded-lg mt-2  w-7/12 h-[60px] overflow-hidden justify-center items-start ${i18n.language === "ar" ? "flex-row-reverse " : ""
                        }`}
                    >
                      <span className="inset-y-0 flex  items-center px-3 py-3.5 text-2xl text-black">
                        EGP
                      </span>

                      <input
                        type="number"
                        className="text-left h-[62px]  w-full focus:outline-none px-3 font-bold text-zinc-800 text-2xl"
                        value={
                          selectedPaymentMethod?.name === "Cash & Bank"
                            ? `${remainingAmount.toFixed(2)}`
                            : i18n.language === "ar" && grandTotal < 0
                              ? `${-grandTotal.toFixed(2)}-`
                              : grandTotal < 0
                                ? grandTotal.toFixed(2) // Display grandTotal when it's less than 0
                                : Number(change)?.toFixed(2) // Format change with two decimal places
                        }
                        readOnly
                      />
                    </div>
                  )}
                  {creditAmount?.response && (
                    <div
                      className={`flex rounded-lg mt-2  w-[300px] h-[60px] overflow-hidden justify-center items-start ${i18n.language === "ar" ? "flex-row-reverse ms-10" : ""
                        }`}
                    >
                      <span className="inset-y-0 flex items-center pl-3 py-3.5 text-2xl text-black">
                        EGP
                      </span>

                      <input
                        type="number"
                        className="text-left h-[62px] w-full focus:outline-none px-2 font-bold text-zinc-800 text-2xl"
                        value={creditAmount?.response}
                        readOnly
                      />
                    </div>
                  )}

                  {showReturnDelivery && (
                    <div
                      className={`flex bg-white mt-1 rounded-lg border border-solid w-7/12 h-[60px] overflow-hidden justify-center items-start ${i18n.language === "ar"
                        ? "flex-row-reverse"
                        : "" || errorMessage
                          ? "border-red-500"
                          : "border-stone-300"
                        }`}
                    >
                      <span className="inset-y-0 flex items-center ps-3 py-3.5 text-2xl text-black">
                        EGP
                      </span>
                      <input
                        id="textInput2"
                        value={returnDeliveryFee}
                        className="bg-white text-left h-[62px] w-full focus:outline-none ps-2 font-bold text-zinc-800 text-2xl"
                        style={{ direction: "ltr" }}
                        onChange={(e) => {
                          let inputValue = e.target.value;

                          inputValue = inputValue.replace(/ز/g, ".");

                          const sanitizedValue = inputValue.replace(
                            /[^0-9.]/g,
                            ""
                          );

                          if (/^\d*\.?\d{0,2}$/.test(sanitizedValue)) {
                            let numericValue = sanitizedValue;

                            if (numericValue.startsWith(".")) {
                              numericValue = "0" + numericValue;
                            }

                            numericValue =
                              numericValue.replace(/^0+(?=\d)/, "") || "0";

                            if (
                              parseFloat(numericValue) > constReturnDeliveryFee
                            ) {
                              setErrorMessage(
                                `Value cannot exceed ${constReturnDeliveryFee}`
                              );
                            } else {
                              setErrorMessage(""); // Clear error message
                            }

                            setReturnDeliveryFee(numericValue);
                          }
                        }}
                        onBlur={() => {
                          if (returnDeliveryFee === 0) {
                            setReturnDeliveryFee(0);
                          }
                        }}
                        maxLength={7}
                      />
                    </div>
                  )}

                  {(selectedOrderFrom?.name === 'self_delivery' || selectedPaymentMethod?.name === "COD") && (


                    <div
                      className={`flex bg-white mt-1 rounded-lg border border-solid border-stone-300 h-[60px] overflow-hidden justify-center items-start w-7/12 ${i18n.language === "ar" ? "flex-row-reverse" : ""
                        }`}
                    >
                      <span className="inset-y-0 flex items-center px-3 py-3.5 text-2xl text-black">
                        EGP
                      </span>
                      <input
                        id={"textInput3"}
                        type="number"
                        autoFocus={true}
                        value={deliveryFee}
                        className="bg-white text-left h-[62px] w-full focus:outline-none px-2 font-bold text-zinc-800 text-2xl"
                        style={{ direction: "ltr" }}
                        onFocus={(e) => {
                          if (deviceType === "tablet") {
                            e.target.blur(); // Prevent keyboard from opening on tablet
                          }
                        }}
                        onChange={(e) => {
                          let inputValue = e.target.value;

                          inputValue = inputValue.replace(/ز/g, ".");

                          const sanitizedValue = inputValue.replace(
                            /[^0-9.]/g,
                            ""
                          );

                          if (/^\d*\.?\d{0,2}$/.test(sanitizedValue)) {
                            setDeliveryFee(sanitizedValue);
                          }
                        }}
                        maxLength={7}
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Change  */}


              <div
                style={{ direction: "ltr" }}
                className={`flex flex-col mt-8 text-4xl font-bold tracking-wider text-center capitalize text-zinc-800 max-md:mt-7 max-md:w-full ${i18n.language === "ar"
                  ? "ms-16"
                  : ""
                  }`}>
                {keypadValues.map((row, rowIndex) => (
                  <div
                    key={rowIndex}
                    className="flex mb-3 max-md:flex-wrap max-md:w-full"
                  >
                    {row.map((value, index) => (
                      <KeypadButton
                        key={index}
                        value={value.value}
                        className={value.className}
                        onClick={() => handleKeypadButtonClick(value.value)}
                        isBankPaymentSelected={isBankPaymentSelected}
                        style={value.isIcon ? { padding: "0.1rem" } : null}
                        grandTotal={grandTotal}
                        selectedPaymentMethod={selectedPaymentMethod}
                        orderFromOptions={orderFromOptions}
                      >
                        {value.isIcon ? (
                          <img
                            src={value.icon}
                            alt="icon"
                            style={{ height: "1.5rem", width: "auto" }}
                          />
                        ) : (
                          value.value
                        )}
                      </KeypadButton>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </main>
        <footer></footer>
      </section>
    </div>
  );
}

export default Payment_Modal;
